import React from "react";
import PropTypes from "prop-types";
import WithFetchCustomers from "../WithFetchCustomers/index";
import { Link } from "react-router-dom";
import FontAwesomeIcon from "@fortawesome/react-fontawesome";
import SearchCustomerForm from "../../components/SearchCustomerForm";
import { compose, setDisplayName } from "recompose";
import CustomerList from "../../components/CustomerList";
import Card from "../../components/Card";

const propTypes = {
  customers: PropTypes.array.isRequired
};

const CustomerTable = compose(
  setDisplayName("CustomerTable"),
  WithFetchCustomers
)(({ match: { url }, customers }) => (
  <CustomerList customers={customers}>
    {({ customer }) => (
      <div className="row justify-content-end">
        <div className="col-auto">
          <Link to={`${url}/${customer.id}`}>
            <FontAwesomeIcon icon="list" />
          </Link>
        </div>
      </div>
    )}
  </CustomerList>
));

const Customers = props => (
  <div className="row">
    <div className="col">
      <Card
        title={
          <h3>
            <b>Customers</b>
          </h3>
        }
        content={
          <div>
            <div className="col">
              <SearchCustomerForm />
            </div>

            <CustomerTable {...props} />
          </div>
        }
      />
    </div>
  </div>
);

Customers.propTypes = propTypes;

export default Customers;
